<template><div></div></template>
<script>
export default {
  mounted() {
    this.$router.push({ name: 'main' });
  },
};
</script>
<style lang="scss"></style>
